import { createGlobalStyle } from "styled-components";
import pageBackground from "../images/page_background.jpg";
import theme from "./theme.js";

const GlobalStyle = createGlobalStyle`
  html {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: 100%;
    font-size: 62.5%;
  }
  *, *:before, *:after {
    -webkit-box-sizing: inherit;
    -moz-box-sizing: inherit;
    box-sizing: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body {
    font-size: 1.6rem;
    font-weight: 400;
    position: relative;
    min-height: 100%;
    font-family: ${theme.fonts.body};
    display: flex;
    line-height: 1.5;
    background-color: ${theme.colors.lightGray};
    color: ${theme.colors.black};
    overflow-x: hidden;
    background-image: url(${pageBackground});
    background-repeat: repeat;
    background-position: center;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.heading};
    font-weight: 500;
  }
  
  #___gatsby {
    flex: 1;
    display: flex;
  }
  
  #gatsby-focus-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  a {
    text-decoration: unset;
    color: inherit;
    transition: opacity 300ms ease-in-out;
    
    &:hover {
      opacity: 0.5;
    }
  }
  
  p {
    margin-bottom: 0;
    
    &:first-child {
      margin-top: 0;
    }
  }
`;

export default GlobalStyle;
